import React from "react";
import styles from "./FurnitureSelectionGuide.module.css";
import { SERIES_DATA } from "../../data/furnitureData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const FurnitureSelectionGuide = () => {
  const seriesTips = [
    {
      id: "director",
      title: "Selecting Executive Furniture",
      tips: [
        "Prioritize ergonomic support for long working hours",
        "Choose premium materials like genuine leather for prestige",
        "Look for adjustable features (height, tilt, armrests)",
        "Consider the size relative to your office space",
      ],
    },
    {
      id: "cafeteria",
      title: "Choosing Cafeteria Furniture",
      tips: [
        "Opt for stackable designs for space efficiency",
        "Select easy-to-clean, stain-resistant materials",
        "Ensure durability for high-traffic areas",
        "Consider weight capacity for commercial use",
      ],
    },
    {
      id: "bar-stool",
      title: "Picking Bar Stools",
      tips: [
        "Determine optimal height for your counter/bar",
        "Look for footrests for comfort during prolonged use",
        "Consider swivel function for flexibility",
        "Choose materials that withstand frequent cleaning",
      ],
    },
  ];

  return (
    <section className={styles.guideSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>
          Expert Guide to Selecting Commercial Furniture
        </h2>
        <p className={styles.sectionSubtitle}>
          Make informed decisions with our professional buying advice
        </p>
      </div>

      <div className={styles.guideContainer}>
        <div className={styles.tipsGrid}>
          {seriesTips.map((series) => (
            <div key={series.id} className={styles.tipCard}>
              <h3 className={styles.tipTitle}>{series.title}</h3>
              <ul className={styles.tipList}>
                {series.tips.map((tip, index) => (
                  <li key={index} className={styles.tipItem}>
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className={styles.tipIcon}
                    />
                    {tip}
                  </li>
                ))}
              </ul>
              <a
                href={`/series/${series.id}`}
                className={styles.viewSeriesButton}
              >
                View {SERIES_DATA.find((s) => s.id === series.id)?.title}
              </a>
            </div>
          ))}
        </div>

        <div className={styles.fullGuide}>
          <h3 className={styles.fullGuideTitle}>
            Comprehensive Furniture Selection Checklist
          </h3>
          <div className={styles.checklistGrid}>
            <div className={styles.checklistCategory}>
              <h4>Material Considerations</h4>
              <ul>
                <li>Commercial-grade durability</li>
                <li>Easy maintenance requirements</li>
                <li>Fire safety ratings</li>
                <li>Eco-friendly certifications</li>
              </ul>
            </div>
            <div className={styles.checklistCategory}>
              <h4>Functional Requirements</h4>
              <ul>
                <li>Weight capacity ratings</li>
                <li>Ergonomic certifications</li>
                <li>Stackability/storage needs</li>
                <li>Warranty coverage</li>
              </ul>
            </div>
            <div className={styles.checklistCategory}>
              <h4>Aesthetic Factors</h4>
              <ul>
                <li>Brand alignment</li>
                <li>Space dimensions</li>
                <li>Color psychology</li>
                <li>Future-proof design</li>
              </ul>
            </div>
          </div>
          <button className={styles.downloadGuideButton}>
            Download Complete Buying Guide (PDF)
          </button>
        </div>
      </div>
    </section>
  );
};

export default FurnitureSelectionGuide;
